<template>
	<div>
		<v-divider></v-divider>
		<div>
			<v-row
				align="center"
				dense
				class="mt-2 pa-2">
				<v-col
					cols="auto"
					class="px-0">
					<v-btn
						color="primary"
						icon
						small>
						<v-icon size="20"> $search </v-icon>
					</v-btn>
				</v-col>
				<v-col cols="2">
					<v-text-field
						v-model="searchName"
						dense
						outlined
						:label="$T('inputs.search-by-name-or-code')"
						hide-details></v-text-field>
				</v-col>
				<v-col cols="2">
					<v-autocomplete
						v-model="searchSection"
						:items="sections"
						clearable
						dense
						outlined
						:label="$T('inputs.search-by-section')"
						hide-details></v-autocomplete>
				</v-col>
			</v-row>

			<div class="d-flex align-center pe-2">
				<v-tabs
					v-model="tabs"
					class="mb-1">
					<v-tab to="#summary">{{ $T('tabs.summary') }}</v-tab>
					<v-tab to="#details">{{ $T('tabs.details') }}</v-tab>
				</v-tabs>
				<v-btn
					:to="{ name: 'salaries' }"
					color="primary"
					small>
					{{ $T('postingSalaries') }}
				</v-btn>
			</div>

			<v-tabs-items v-model="tabs">
				<!-- summary -->
				<v-tab-item
					value="summary"
					class="pa-2">
					<bee-handy-table
						:headers="summaryHeaders"
						:items="summaryItems"
						:data-table-props="{ disableSort: true }"
						dense
						zebra
						fixed-header
						:height="$vuetify.breakpoint.height - 170"
						hide-default-footer>
						<template v-slot:item.finalSalary="{ item }">
							{{
								$options.filters.numberFormat(
									item.baseSalary -
										item.absenceDiscount -
										item.lateAndEarlyDiscount +
										item.financialPenalty +
										item.financialRewards,
								)
							}}
						</template>
					</bee-handy-table>
				</v-tab-item>

				<!-- details -->
				<v-tab-item
					value="details"
					class="pa-2">
					<bee-handy-table
						:headers="detailsHeaders"
						:items="detailsItems"
						:data-table-props="{ disableSort: true }"
						dense
						zebra
						fixed-header
						:height="$vuetify.breakpoint.height - 170"
						hide-default-footer>
					</bee-handy-table>
				</v-tab-item>
			</v-tabs-items>
		</div>
	</div>
</template>

<script>
export default {
	name: 'AddSalaries',

	data() {
		return {
			tabs: null,
			searchName: null,
			searchSection: null,
			searchDate: null,

			summaryHeaders: [
				{
					text: this.$T('summaryTable.employee'),
					name: 'employee',
					value: 'employee',
					columnClass: 'px-1 text-caption',
					divider: true,
					align: 'center',
				},
				{
					text: this.$T('summaryTable.section'),
					name: 'section',
					value: 'section',
					columnClass: 'px-1 text-caption',
					divider: true,
					align: 'center',
				},
				{
					text: this.$T('summaryTable.baseSalary'),
					name: 'baseSalary',
					value: 'baseSalary',
					type: 'number-format',
					columnClass: 'px-1 text-caption',
					divider: true,
					align: 'center',
				},
				{
					text: this.$T('summaryTable.absenceDiscount'),
					name: 'absenceDiscount',
					value: 'absenceDiscount',
					type: 'number-format',
					columnClass: 'px-1 text-caption',
					divider: true,
					align: 'center',
				},
				{
					text: this.$T('summaryTable.lateAndEarlyDiscount'),
					name: 'lateAndEarlyDiscount',
					value: 'lateAndEarlyDiscount',
					type: 'number-format',
					columnClass: 'px-1 text-caption',
					divider: true,
					align: 'center',
				},
				{
					text: this.$T('summaryTable.financialPenalty'),
					name: 'financialPenalty',
					value: 'financialPenalty',
					type: 'number-format',
					columnClass: 'px-1 text-caption',
					divider: true,
					align: 'center',
				},
				{
					text: this.$T('summaryTable.financialRewards'),
					name: 'financialRewards',
					value: 'financialRewards',
					type: 'number-format',
					columnClass: 'px-1 text-caption',
					divider: true,
					align: 'center',
				},
				{
					text: this.$T('summaryTable.extra'),
					name: 'extra',
					value: 'extra',
					type: 'number-format',
					columnClass: 'px-1 text-caption',
					divider: true,
					align: 'center',
				},
				{
					text: this.$T('summaryTable.finalSalary'),
					name: 'finalSalary',
					value: 'finalSalary',
					type: 'number-format',
					columnClass: 'px-1 text-caption',
					divider: true,
					align: 'center',
				},
				// { text: '', name: 'actions', value: 'actions' },
			],
			detailsHeaders: [
				{
					text: this.$T('detailsTable.employee'),
					name: 'employee',
					value: 'employee',
					columnClass: 'px-1 text-caption',
					divider: true,
					align: 'center',
				},
				{
					text: this.$T('detailsTable.section'),
					name: 'section',
					value: 'section',
					columnClass: 'px-1 text-caption',
					divider: true,
					align: 'center',
				},
				{
					text: this.$T('detailsTable.chipNo'),
					name: 'chipNo',
					value: 'chipNo',
					type: 'number-format',
					columnClass: 'px-1 text-caption',
					divider: true,
					align: 'center',
				},
				{
					text: this.$T('detailsTable.month'),
					name: 'month',
					value: 'month',
					type: 'number-format',
					columnClass: 'px-1 text-caption',
					divider: true,
					align: 'center',
				},
				{
					text: this.$T('detailsTable.year'),
					name: 'year',
					value: 'year',
					type: 'number-format',
					columnClass: 'px-1 text-caption',
					divider: true,
					align: 'center',
				},
				{
					text: this.$T('detailsTable.baseSalaryOnStart'),
					name: 'baseSalaryOnStart',
					value: 'baseSalaryOnStart',
					type: 'number-format',
					columnClass: 'px-1 text-caption',
					divider: true,
					align: 'center',
				},
				{
					text: this.$T('detailsTable.baseSalaryOnAdmission'),
					name: 'baseSalaryOnAdmission',
					value: 'baseSalaryOnAdmission',
					type: 'number-format',
					columnClass: 'px-1 text-caption',
					divider: true,
					align: 'center',
				},
				{
					text: this.$T('detailsTable.academic'),
					name: 'academic',
					value: 'academic',
					type: 'number-format',
					columnClass: 'px-1 text-caption',
					divider: true,
					align: 'center',
				},
				{
					text: this.$T('detailsTable.practical'),
					name: 'practical',
					value: 'practical',
					type: 'number-format',
					columnClass: 'px-1 text-caption',
					divider: true,
					align: 'center',
				},
				{
					text: this.$T('detailsTable.quality'),
					name: 'quality',
					value: 'quality',
					type: 'number-format',
					columnClass: 'px-1 text-caption',
					divider: true,
					align: 'center',
				},
				{
					text: this.$T('detailsTable.responsibility'),
					name: 'responsibility',
					value: 'responsibility',
					type: 'number-format',
					columnClass: 'px-1 text-caption',
					divider: true,
					align: 'center',
				},
				{
					text: this.$T('detailsTable.inflation'),
					name: 'inflation',
					value: 'inflation',
					type: 'number-format',
					columnClass: 'px-1 text-caption',
					divider: true,
					align: 'center',
				},
				{
					text: this.$T('detailsTable.food'),
					name: 'food',
					value: 'food',
					type: 'number-format',
					columnClass: 'px-1 text-caption',
					divider: true,
					align: 'center',
				},
				{
					text: this.$T('detailsTable.travel'),
					name: 'travel',
					value: 'travel',
					type: 'number-format',
					columnClass: 'px-1 text-caption',
					divider: true,
					align: 'center',
				},
				{
					text: this.$T('detailsTable.seniority'),
					name: 'seniority',
					value: 'seniority',
					type: 'number-format',
					columnClass: 'px-1 text-caption',
					divider: true,
					align: 'center',
				},
				{
					text: this.$T('detailsTable.penaltiesAndRewards'),
					name: 'penaltiesAndRewards',
					value: 'penaltiesAndRewards',
					type: 'number-format',
					columnClass: 'px-1 text-caption',
					divider: true,
					align: 'center',
				},
			],

			// ! delete
			sections: ['قسم الميكانيك', 'قسم الصيانة الكهرائية', 'قسم الموارد البشرية', 'قسم البرمجة'],

			summaryItems: [
				{
					employee: 'احمد محمد',
					section: 'هندسة الميكانيك',
					baseSalary: 200000,
					absenceDiscount: 2000,
					lateAndEarlyDiscount: 10000,
					financialPenalty: 4000,
					financialRewards: 3000,
					extra: 2500,
				},
				{
					employee: 'احمد محمد',
					section: 'هندسة الميكانيك',
					baseSalary: 200000,
					absenceDiscount: 2000,
					lateAndEarlyDiscount: 10000,
					financialPenalty: 4000,
					financialRewards: 3000,
					extra: 2500,
				},
				{
					employee: 'احمد محمد',
					section: 'هندسة الميكانيك',
					baseSalary: 200000,
					absenceDiscount: 2000,
					lateAndEarlyDiscount: 10000,
					financialPenalty: 4000,
					financialRewards: 3000,
					extra: 2500,
				},
			],
			detailsItems: [
				{
					employee: 'احمد محمد',
					section: 'هندسة معلوماتية',
					chipNo: '1',
					month: '5',
					year: '2022',
					baseSalaryOnStart: 20000,
					baseSalaryOnAdmission: 10000,
					academic: 3000,
					practical: 200,
					quality: 1000,
					responsibility: 90,
					inflation: 3000,
					food: 2500,
					travel: 2400,
					seniority: 21000,
					penaltiesAndRewards: 2000,
				},
				{
					employee: 'احمد محمد',
					section: 'هندسة معلوماتية',
					chipNo: '1',
					month: '5',
					year: '2022',
					baseSalaryOnStart: 20000,
					baseSalaryOnAdmission: 10000,
					academic: 3000,
					practical: 200,
					quality: 1000,
					responsibility: 90,
					inflation: 3000,
					food: 2500,
					travel: 2400,
					seniority: 21000,
					penaltiesAndRewards: 2000,
				},
				{
					employee: 'احمد محمد',
					section: 'هندسة معلوماتية',
					chipNo: '1',
					month: '5',
					year: '2022',
					baseSalaryOnStart: 20000,
					baseSalaryOnAdmission: 10000,
					academic: 3000,
					practical: 200,
					quality: 1000,
					responsibility: 90,
					inflation: 3000,
					food: 2500,
					travel: 2400,
					seniority: 21000,
					penaltiesAndRewards: 2000,
				},
			],
		};
	},
};
</script>
